import { FC } from 'react';

import SunshineCard from 'components/_core/SunshineCard';
import { getDeviceInformation } from 'helpers/device';

import {
  compareConnectionDate,
  isDeviceBlocked,
  isDeviceTrusted,
} from '../../helpers';
import DeviceComponent from '../Device';
import { Props } from './types';

const DeviceList: FC<Props> = ({
  devices,
  selectedDevice,
  setSelectedDevice,
}) => {
  const currentDeviceInformation = getDeviceInformation();

  const currentDevice = devices.find(
    (device) => device.token === currentDeviceInformation.token,
  );

  const trustedDevices = devices
    .filter(
      (device) =>
        device.authenticationDeviceId !==
          currentDevice?.authenticationDeviceId && isDeviceTrusted(device),
    )
    .sort(compareConnectionDate);

  const blockedDevices = devices
    .filter(
      (device) =>
        device.authenticationDeviceId !==
          currentDevice?.authenticationDeviceId && isDeviceBlocked(device),
    )
    .sort(compareConnectionDate);

  return (
    <SunshineCard.Group>
      {currentDevice ? (
        <DeviceComponent
          device={currentDevice}
          key={currentDevice.authenticationDeviceId}
          onSelect={setSelectedDevice}
          selectedDevice={selectedDevice}
        />
      ) : null}

      {trustedDevices.map((device) => (
        <DeviceComponent
          device={device}
          key={device.authenticationDeviceId}
          onSelect={setSelectedDevice}
          selectedDevice={selectedDevice}
        />
      ))}

      {blockedDevices.map((device) => (
        <DeviceComponent
          device={device}
          key={device.authenticationDeviceId}
          onSelect={setSelectedDevice}
          selectedDevice={selectedDevice}
        />
      ))}
    </SunshineCard.Group>
  );
};

export default DeviceList;
